import {IFeature} from "../types";

export function geometryIsValid (features: IFeature[]) {
    if (!features || ! features.length) {
        return false;
    }
    let condition = true;
    let i = -1;
    while (++i < features.length) {
        condition = condition && validateSingleFeature(features[i]);
    }
    // console.log(features);
    return condition;
}

function validateSingleFeature (feature: IFeature) {
    let coords;
    switch (feature.geometry.type) {
        case 'LineString':
            if (feature.geometry.coordinates.length < 2) {
                return false;
            }
            return feature.geometry.coordinates[0].join('') !== feature.geometry.coordinates[1].join('');

        case 'Polygon':
            coords = feature.geometry.coordinates[0] as number[][];
            if (coords.length < 3) {
                return false;
            }
            return !(coords[0].join('') === coords[1].join('') ||
                coords[1].join('') === coords[2].join('') ||
                coords[0].join('') === coords[2].join(''));


        case 'MultiPolygon':
            coords = feature.geometry.coordinates[0][0] as number[][];
            if (coords.length < 3) {
                return false;
            }
            return !(coords[0].join('') === coords[1].join('') ||
                coords[1].join('') === coords[2].join('') ||
                coords[0].join('') === coords[2].join(''));
        default:
            return true;
    }
}

const validationMessages = {
    line: 'A Line must have two or more distinct points',
    polygon: 'A Polygon must have three or more distinct points'
}

export function geometryValidationMessage (features: IFeature[]) {
    if (!geometryIsValid(features) && features.length) {
        switch (features[0].geometry.type) {
            case 'LineString':
                return validationMessages.line;
            case 'Polygon':
            case 'MultiPolygon':
                return validationMessages.polygon;
        }

    }
    return null;
}
